export default __webpack_public_path__ + "static/media/checkokaut.23db4705.svg";